import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Composant SEO pour gérer les balises meta et canonical dynamiquement
 * @param {string} title - Titre de la page
 * @param {string} description - Description de la page
 * @param {string} canonical - URL canonique (optionnel, calculé automatiquement si non fourni)
 */
export default function SEO({ title, description, canonical }) {
  const location = useLocation();
  const baseUrl = "https://chatel-guyon-hotel-cure-thermes.fr";

  useEffect(() => {
    // Mettre à jour le titre
    if (title) {
      document.title = title;
    }

    // Mettre à jour la description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      }
    }

    // Mettre à jour le canonical
    const canonicalUrl = canonical || `${baseUrl}${location.pathname}`;
    let link = document.querySelector('link[rel="canonical"]');

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", canonicalUrl);

    // Mettre à jour Open Graph
    updateMetaTag("property", "og:title", title);
    updateMetaTag("property", "og:description", description);
    updateMetaTag("property", "og:url", canonicalUrl);

    // Mettre à jour Twitter
    updateMetaTag("name", "twitter:title", title);
    updateMetaTag("name", "twitter:description", description);
    updateMetaTag("name", "twitter:url", canonicalUrl);
  }, [title, description, canonical, location.pathname]);

  return null;
}

// Fonction utilitaire pour mettre à jour les meta tags
function updateMetaTag(attribute, attributeValue, content) {
  if (!content) return;

  let meta = document.querySelector(`meta[${attribute}="${attributeValue}"]`);
  if (meta) {
    meta.setAttribute("content", content);
  }
}
